"use strict";
/// <reference types="node" />
require("./app");



/** WEBPACK FOOTER **
 ** ./app/entry.ts
 **/